import { defineEffect } from '../../../core/effect';

/**
 * **チェーンのリンクの処理が終わった**（Issue #571）。そのリンクが置いた対象の照準の枠を消す（`clears`）。**絵は持たない**。
 * 照準の枠の key は `<チェーンの番号>:<uid>`（`become_target.js`）なので、番号の頭で束ねて消す。
 */
export default defineEffect({
  situation: 'chain_solved',
  role: 'effect',
  label: 'チェーンの処理の終わり（対象の枠を消す）',
  color: '#8a8aa0',
  duration: () => 1,
  clears: ({ payload }) => {
    const chain = Number(payload?.chain ?? payload?.link?.chain) || 0;
    return chain ? [{ mark: 'targetSight', prefix: `${chain}:` }] : [];
  },
}, 'chain_solved_effect.js');
